import { render, staticRenderFns } from "./CustomerServiceSettingIndex.vue?vue&type=template&id=59cb4ebf&scoped=true&"
import script from "./CustomerServiceSettingIndex.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceSettingIndex.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceSettingIndex.vue?vue&type=style&index=0&id=59cb4ebf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cb4ebf",
  null
  
)

export default component.exports